import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'modals',
  standalone: true,
  imports: [NgClass],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {
  @ViewChild('modal',{static: true,read: ElementRef}) dom_modal!: ElementRef;
  @Input() classes: string = 'max-w-96 w-full p-3';
  @Input() buttonPosition: 'start'|'center'|'end' = 'start';
  @Input() disabled: boolean = false;
  @Input() closeOnSubmit: boolean = true;
  title: string = '';
  message!: string;
  positive_text: string = '';
  negative_text: string = '';
  positive_fn!: Function;
  negative_fn!: Function;
  type: 'info'|'confirm'|'confirm-warning' = 'info';

  constructor() {}

  public showInfo(title: string,
                  message: string,
                  positiveText: string,
                  positiveFn: Function = ()=>{}){
    this.title = title;
    this.message = message;
    this.positive_text = positiveText;
    this.positive_fn = positiveFn;
    this.type = 'info';
    this.onShow();
  }
  public showConfirm(title: string,
                     message: string,
                     positiveText: string,
                     negativeText:string,
                     positiveFn: Function = ()=>{},
                     negativeFn: Function = ()=>{}){

    this.title = title;
    this.message = message;
    this.positive_text = positiveText;
    this.negative_text = negativeText;
    this.positive_fn = positiveFn;
    this.negative_fn = negativeFn;
    this.type = 'confirm';
    this.onShow();

  }
  public showConfirmWarning(title: string,
                            message: string,
                            positiveText: string,
                            negativeText:string,
                            positiveFn: Function = ()=>{},
                            negativeFn: Function = ()=>{}){

    this.title = title;
    this.message = message;
    this.positive_text = positiveText;
    this.negative_text = negativeText;
    this.positive_fn = positiveFn;
    this.negative_fn = negativeFn;
    this.type = 'confirm-warning';
    this.onShow();
  }
  positiveAction(){
    if(this.positive_fn){
      this.positive_fn();
    }
    this.closeOnSubmit && this.onDismiss();
  }
  negativeAction(){
    if(this.negative_fn){
      this.negative_fn();
    }
    this.onDismiss();
  }
  onDismiss(){
    const modal = this.dom_modal.nativeElement;

    modal.classList.add('closing');

    modal.addEventListener(
      'animationend',
      () => {
        modal.classList.remove('closing');
        modal.close();
      },
      { once: true }
    );
  }
  onShow(){
    this.dom_modal.nativeElement.showModal();
  }
}
